import ImageUploader from "../../components/ImageUploader";
import Toggle from "../../components/Toggle";

const inputCls =
  "w-full mt-1 bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)]";

function Row({ title, desc, checked, onChange, testid }) {
  return (
    <div className="flex items-center justify-between border border-[#E8E4D9] rounded-lg px-4 py-3">
      <div>
        <p className="text-sm font-medium text-[#1A231C]">{title}</p>
        {desc && <p className="text-xs text-[#5C665D]">{desc}</p>}
      </div>
      <Toggle checked={checked} onChange={onChange} testid={testid} />
    </div>
  );
}

export default function AdminAppearance({ settings, setField, onSave, saving }) {
  return (
    <form onSubmit={onSave} className="mt-6 max-w-2xl space-y-6">
      {/* Hero */}
      <div className="bg-white border border-[#E8E4D9] rounded-xl p-6 space-y-4">
        <h3 className="font-display font-semibold text-lg text-[#1A231C]">Homepage Hero</h3>
        <Row title="Show hero section" checked={!!settings.hero_enabled} onChange={(v) => setField("hero_enabled", v)} testid="toggle-hero" />
        <div>
          <label className="text-sm font-medium text-[#1A231C]">Headline</label>
          <input data-testid="hero-title" value={settings.hero_title || ""} onChange={(e) => setField("hero_title", e.target.value)} placeholder="Everything for your home..." className={inputCls} />
        </div>
        <div>
          <label className="text-sm font-medium text-[#1A231C]">Tagline</label>
          <textarea data-testid="hero-subtitle" value={settings.hero_subtitle || ""} onChange={(e) => setField("hero_subtitle", e.target.value)} rows={2} className={inputCls} />
        </div>
        <ImageUploader label="Hero Image" testid="hero-image" value={settings.hero_image_url} onChange={(v) => setField("hero_image_url", v)} />
      </div>

      {/* Category grid */}
      <div className="bg-white border border-[#E8E4D9] rounded-xl p-6 space-y-4">
        <h3 className="font-display font-semibold text-lg text-[#1A231C]">Sections</h3>
        <Row title="Show 'Shop by category' grid" checked={!!settings.show_category_grid} onChange={(v) => setField("show_category_grid", v)} testid="toggle-category-grid" />
      </div>

      {/* Promo */}
      <div className="bg-white border border-[#E8E4D9] rounded-xl p-6 space-y-4">
        <h3 className="font-display font-semibold text-lg text-[#1A231C]">Promo Banner</h3>
        <Row title="Show promo banner on homepage" checked={!!settings.promo_enabled} onChange={(v) => setField("promo_enabled", v)} testid="toggle-promo" />
        <div>
          <label className="text-sm font-medium text-[#1A231C]">Promo Title</label>
          <input data-testid="promo-title" value={settings.promo_title || ""} onChange={(e) => setField("promo_title", e.target.value)} className={inputCls} />
        </div>
        <div>
          <label className="text-sm font-medium text-[#1A231C]">Promo Subtitle</label>
          <input data-testid="promo-subtitle" value={settings.promo_subtitle || ""} onChange={(e) => setField("promo_subtitle", e.target.value)} className={inputCls} />
        </div>
        <div>
          <label className="text-sm font-medium text-[#1A231C]">Promo Link (e.g. /shop?category=food)</label>
          <input data-testid="promo-link" value={settings.promo_link || ""} onChange={(e) => setField("promo_link", e.target.value)} placeholder="/shop" className={inputCls} />
        </div>
        <ImageUploader label="Promo Image" testid="promo-image" value={settings.promo_image_url} onChange={(v) => setField("promo_image_url", v)} />
      </div>

      <button data-testid="appearance-save" type="submit" disabled={saving} className="bg-[var(--brand-primary)] text-white px-6 py-3 rounded-lg font-medium hover:bg-[var(--brand-primary-hover)] transition-colors disabled:opacity-60">
        {saving ? "Saving..." : "Save Appearance"}
      </button>
    </form>
  );
}
